import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSlideTallAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSlideTallAdd"><Path d="M4.5 2.5V21.5H19.5V2.5H4.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 12H12M12 12H15.5M12 12V15.5M12 12L12 8.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSlideTallAdd;
